"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmitButton = exports.Root = exports.Form = exports.Field = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(0, 0, 1, 1),
  display: 'flex',
  flexDirection: 'column'
}));
const Form = exports.Form = (0, _mui.styled)('form')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
}));
const Field = exports.Field = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(1),
  position: 'relative'
}));
const SubmitButton = exports.SubmitButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  marginTop: theme.spacing(3)
}));
